import React from 'react';

export const VotingStatus = ({ status }) => {
  if (!status) return null;

  const { voted, pending, totalPlayers, votesIn, allVotesIn } = status;

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h4 className="font-medium text-gray-700">Voting Progress</h4>
        <span className="text-sm text-gray-500">
          {votesIn} / {totalPlayers} votes
        </span>
      </div>

      {/* Progress bar */}
      <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
        <div
          className={`h-full transition-all duration-500 ${
            allVotesIn ? 'bg-green-500' : 'bg-primary-500'
          }`}
          style={{ width: `${totalPlayers > 0 ? (votesIn / totalPlayers) * 100 : 0}%` }}
        />
      </div>

      {/* Voter lists */}
      <div className="space-y-2">
        {voted.length > 0 && (
          <div>
            <span className="text-xs font-medium text-gray-500 uppercase">Voted</span>
            <div className="flex flex-wrap gap-1 mt-1">
              {voted.map((voter) => (
                <span
                  key={voter.id}
                  className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800"
                >
                  {voter.displayName}
                </span>
              ))}
            </div>
          </div>
        )}

        {pending.length > 0 && (
          <div>
            <span className="text-xs font-medium text-gray-500 uppercase">Waiting on</span>
            <div className="flex flex-wrap gap-1 mt-1">
              {pending.map((voter) => (
                <span
                  key={voter.id}
                  className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-600"
                >
                  {voter.displayName}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>

      {allVotesIn && (
        <div className="text-center py-2 bg-green-50 rounded-lg">
          <span className="text-sm font-medium text-green-700">
            All votes are in!
          </span>
        </div>
      )}
    </div>
  );
};
